import Axios from 'axios'
import FetcherHelper from '@/utils/fetcherHelper'
import Config from '@/config'

export default class RoleProxy {
  static get stratesBaseUrl () {
    return `${Config.apiMgmtBaseUrl}`
  }

  static get emptyUser () {
    return {
      login: '',
      firstname: '',
      lastname: '',
      email: '',
      telephoneNumber: '',
      mobilePhone: '',
      function: '',
      comment: '',
    }
  }

  static list () {
    return new Promise((resolve, reject) => {
      Axios.get(`${RoleProxy.stratesBaseUrl}/role`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static get (id) {
    return new Promise((resolve, reject) => {
      Axios.get(`${RoleProxy.stratesBaseUrl}/role/${id}`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static delete (id) {
    return new Promise((resolve, reject) => {
      Axios.delete(`${RoleProxy.stratesBaseUrl}/role/${id}`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static update (role) {
    return new Promise((resolve, reject) => {
      Axios.put(`${RoleProxy.stratesBaseUrl}/role/${role.id}`, role, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }

  static create (role) {
    return new Promise((resolve, reject) => {
      Axios.post(`${RoleProxy.stratesBaseUrl}/role`, role, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data)
        }).catch(reject)
    })
  }
}